var map = {
	"./App": [
		"3dfd",
		9
	],
	"./App.vue": [
		"3dfd",
		9
	],
	"./api": [
		"365c",
		9
	],
	"./api/": [
		"365c",
		9
	],
	"./api/AuthorWork": [
		"19b0",
		9
	],
	"./api/AuthorWork.js": [
		"19b0",
		9
	],
	"./api/BibliographyWork": [
		"fac7",
		9
	],
	"./api/BibliographyWork.js": [
		"fac7",
		9
	],
	"./api/CommonWork": [
		"c706",
		9
	],
	"./api/CommonWork.js": [
		"c706",
		9
	],
	"./api/CouncilMember": [
		"e1c1",
		9
	],
	"./api/CouncilMember.js": [
		"e1c1",
		9
	],
	"./api/EfficiencyMetric": [
		"ea2d",
		9
	],
	"./api/EfficiencyMetric.js": [
		"ea2d",
		9
	],
	"./api/File": [
		"392b",
		9
	],
	"./api/File.js": [
		"392b",
		9
	],
	"./api/JournalEditorialBoard": [
		"c8df",
		9
	],
	"./api/JournalEditorialBoard.js": [
		"c8df",
		9
	],
	"./api/Opposition": [
		"bef3",
		9
	],
	"./api/Opposition.js": [
		"bef3",
		9
	],
	"./api/Report": [
		"12b6",
		9
	],
	"./api/Report.js": [
		"12b6",
		9
	],
	"./api/auth": [
		"3786",
		9
	],
	"./api/auth.js": [
		"3786",
		9
	],
	"./api/base": [
		"a417",
		9
	],
	"./api/base.js": [
		"a417",
		9
	],
	"./api/directories/AcademicDegree": [
		"c81f",
		9
	],
	"./api/directories/AcademicDegree.js": [
		"c81f",
		9
	],
	"./api/directories/Activity": [
		"8318",
		9
	],
	"./api/directories/Activity.js": [
		"8318",
		9
	],
	"./api/directories/Bibliography": [
		"3409",
		9
	],
	"./api/directories/Bibliography.js": [
		"3409",
		9
	],
	"./api/directories/Catalog": [
		"481d",
		9
	],
	"./api/directories/Catalog.js": [
		"481d",
		9
	],
	"./api/directories/ContestResult": [
		"f0b6",
		9
	],
	"./api/directories/ContestResult.js": [
		"f0b6",
		9
	],
	"./api/directories/CooperationType": [
		"2016",
		9
	],
	"./api/directories/CooperationType.js": [
		"2016",
		9
	],
	"./api/directories/CouncilName": [
		"2e4c",
		9
	],
	"./api/directories/CouncilName.js": [
		"2e4c",
		9
	],
	"./api/directories/Country": [
		"1722",
		9
	],
	"./api/directories/Country.js": [
		"1722",
		9
	],
	"./api/directories/Department": [
		"816b",
		9
	],
	"./api/directories/Department.js": [
		"816b",
		9
	],
	"./api/directories/DissertationDegree": [
		"f368",
		9
	],
	"./api/directories/DissertationDegree.js": [
		"f368",
		9
	],
	"./api/directories/Duty": [
		"c0f1",
		9
	],
	"./api/directories/Duty.js": [
		"c0f1",
		9
	],
	"./api/directories/EditorialBoardRole": [
		"5b71",
		9
	],
	"./api/directories/EditorialBoardRole.js": [
		"5b71",
		9
	],
	"./api/directories/EducationalPublicationType": [
		"a92f",
		9
	],
	"./api/directories/EducationalPublicationType.js": [
		"a92f",
		9
	],
	"./api/directories/Employee": [
		"940b",
		9
	],
	"./api/directories/Employee.js": [
		"940b",
		9
	],
	"./api/directories/EmployeePosition": [
		"fb08",
		9
	],
	"./api/directories/EmployeePosition.js": [
		"fb08",
		9
	],
	"./api/directories/EventFormat": [
		"604a",
		9
	],
	"./api/directories/EventFormat.js": [
		"604a",
		9
	],
	"./api/directories/EventType": [
		"7b25",
		9
	],
	"./api/directories/EventType.js": [
		"7b25",
		9
	],
	"./api/directories/Faculty": [
		"5800",
		9
	],
	"./api/directories/Faculty.js": [
		"5800",
		9
	],
	"./api/directories/FileType": [
		"1299",
		9
	],
	"./api/directories/FileType.js": [
		"1299",
		9
	],
	"./api/directories/ForbiddenPeriod": [
		"6394",
		9
	],
	"./api/directories/ForbiddenPeriod.js": [
		"6394",
		9
	],
	"./api/directories/ForeignOrganization": [
		"bca5",
		9
	],
	"./api/directories/ForeignOrganization.js": [
		"bca5",
		9
	],
	"./api/directories/FundingRecipient": [
		"38b2",
		9
	],
	"./api/directories/FundingRecipient.js": [
		"38b2",
		9
	],
	"./api/directories/GuideType": [
		"5dd1",
		9
	],
	"./api/directories/GuideType.js": [
		"5dd1",
		9
	],
	"./api/directories/Highschool": [
		"9a81",
		9
	],
	"./api/directories/Highschool.js": [
		"9a81",
		9
	],
	"./api/directories/InculcationLevel": [
		"f8b0",
		9
	],
	"./api/directories/InculcationLevel.js": [
		"f8b0",
		9
	],
	"./api/directories/InteractionType": [
		"7687",
		9
	],
	"./api/directories/InteractionType.js": [
		"7687",
		9
	],
	"./api/directories/Magazine": [
		"f0fa",
		9
	],
	"./api/directories/Magazine.js": [
		"f0fa",
		9
	],
	"./api/directories/NirLevel": [
		"1155",
		9
	],
	"./api/directories/NirLevel.js": [
		"1155",
		9
	],
	"./api/directories/NirType": [
		"7df8",
		9
	],
	"./api/directories/NirType.js": [
		"7df8",
		9
	],
	"./api/directories/Organization": [
		"9555",
		9
	],
	"./api/directories/Organization.js": [
		"9555",
		9
	],
	"./api/directories/ParticipantQuantity": [
		"4f06",
		9
	],
	"./api/directories/ParticipantQuantity.js": [
		"4f06",
		9
	],
	"./api/directories/ParticipationKind": [
		"9e20",
		9
	],
	"./api/directories/ParticipationKind.js": [
		"9e20",
		9
	],
	"./api/directories/ParticipationStatus": [
		"8184",
		9
	],
	"./api/directories/ParticipationStatus.js": [
		"8184",
		9
	],
	"./api/directories/PerformanceType": [
		"a6e9",
		9
	],
	"./api/directories/PerformanceType.js": [
		"a6e9",
		9
	],
	"./api/directories/Period": [
		"0033",
		9
	],
	"./api/directories/Period.js": [
		"0033",
		9
	],
	"./api/directories/PersonTitle": [
		"e824",
		9
	],
	"./api/directories/PersonTitle.js": [
		"e824",
		9
	],
	"./api/directories/Position": [
		"bf9b",
		9
	],
	"./api/directories/Position.js": [
		"bf9b",
		9
	],
	"./api/directories/ProtectionPlace": [
		"ab2f",
		9
	],
	"./api/directories/ProtectionPlace.js": [
		"ab2f",
		9
	],
	"./api/directories/PublicationForm": [
		"4c13",
		9
	],
	"./api/directories/PublicationForm.js": [
		"4c13",
		9
	],
	"./api/directories/PublishingHouse": [
		"d82d",
		9
	],
	"./api/directories/PublishingHouse.js": [
		"d82d",
		9
	],
	"./api/directories/Quarter": [
		"f2e7",
		9
	],
	"./api/directories/Quarter.js": [
		"f2e7",
		9
	],
	"./api/directories/Reward": [
		"7030",
		9
	],
	"./api/directories/Reward.js": [
		"7030",
		9
	],
	"./api/directories/SalaryRate": [
		"3da4",
		9
	],
	"./api/directories/SalaryRate.js": [
		"3da4",
		9
	],
	"./api/directories/ScienceStep": [
		"9c9a",
		9
	],
	"./api/directories/ScienceStep.js": [
		"9c9a",
		9
	],
	"./api/directories/ScientDepartment": [
		"2347",
		9
	],
	"./api/directories/ScientDepartment.js": [
		"2347",
		9
	],
	"./api/directories/ScientistName": [
		"0de6",
		9
	],
	"./api/directories/ScientistName.js": [
		"0de6",
		9
	],
	"./api/directories/Speciality": [
		"bf48",
		9
	],
	"./api/directories/Speciality.js": [
		"bf48",
		9
	],
	"./api/directories/State": [
		"386e",
		9
	],
	"./api/directories/State.js": [
		"386e",
		9
	],
	"./api/directories/Status": [
		"1a27",
		9
	],
	"./api/directories/Status.js": [
		"1a27",
		9
	],
	"./api/directories/VAC": [
		"f7de",
		9
	],
	"./api/directories/VAC.js": [
		"f7de",
		9
	],
	"./api/directories/WhiteListLevel": [
		"060a",
		9
	],
	"./api/directories/WhiteListLevel.js": [
		"060a",
		9
	],
	"./api/directories/WorkType": [
		"de6d",
		9
	],
	"./api/directories/WorkType.js": [
		"de6d",
		9
	],
	"./api/directories/Year": [
		"450d",
		9
	],
	"./api/directories/Year.js": [
		"450d",
		9
	],
	"./api/index": [
		"365c",
		9
	],
	"./api/index.js": [
		"365c",
		9
	],
	"./api/print": [
		"69f8",
		9
	],
	"./api/print.js": [
		"69f8",
		9
	],
	"./api/works/Contest": [
		"edde",
		9
	],
	"./api/works/Contest.js": [
		"edde",
		9
	],
	"./api/works/CooperationInformation": [
		"cc7c",
		9
	],
	"./api/works/CooperationInformation.js": [
		"cc7c",
		9
	],
	"./api/works/Dissertation": [
		"5b01",
		9
	],
	"./api/works/Dissertation.js": [
		"5b01",
		9
	],
	"./api/works/EducationalPublication": [
		"8151",
		9
	],
	"./api/works/EducationalPublication.js": [
		"8151",
		9
	],
	"./api/works/ForeignCitation": [
		"34bd",
		9
	],
	"./api/works/ForeignCitation.js": [
		"34bd",
		9
	],
	"./api/works/Grant": [
		"3cf4",
		9
	],
	"./api/works/Grant.js": [
		"3cf4",
		9
	],
	"./api/works/Incalculation": [
		"6ff1",
		9
	],
	"./api/works/Incalculation.js": [
		"6ff1",
		9
	],
	"./api/works/Monography": [
		"edbb",
		9
	],
	"./api/works/Monography.js": [
		"edbb",
		9
	],
	"./api/works/NirAccomplishment": [
		"791c",
		9
	],
	"./api/works/NirAccomplishment.js": [
		"791c",
		9
	],
	"./api/works/NirCompensationAgreement": [
		"41c7",
		9
	],
	"./api/works/NirCompensationAgreement.js": [
		"41c7",
		9
	],
	"./api/works/OverseasEvent": [
		"903b",
		9
	],
	"./api/works/OverseasEvent.js": [
		"903b",
		9
	],
	"./api/works/PeerReviewedPublication": [
		"9026",
		9
	],
	"./api/works/PeerReviewedPublication.js": [
		"9026",
		9
	],
	"./api/works/Performance": [
		"eddd",
		9
	],
	"./api/works/Performance.js": [
		"eddd",
		9
	],
	"./api/works/PrePrint": [
		"a991",
		9
	],
	"./api/works/PrePrint.js": [
		"a991",
		9
	],
	"./api/works/PublicOrganizationParticipation": [
		"f39c",
		9
	],
	"./api/works/PublicOrganizationParticipation.js": [
		"f39c",
		9
	],
	"./api/works/Publication": [
		"2d57",
		9
	],
	"./api/works/Publication.js": [
		"2d57",
		9
	],
	"./api/works/ScientificPracticalEvent": [
		"eb57",
		9
	],
	"./api/works/ScientificPracticalEvent.js": [
		"eb57",
		9
	],
	"./api/works/StateAward": [
		"bf3f",
		9
	],
	"./api/works/StateAward.js": [
		"bf3f",
		9
	],
	"./api/works/StudentGuide": [
		"b70d",
		9
	],
	"./api/works/StudentGuide.js": [
		"b70d",
		9
	],
	"./api/works/WinningScientificCompetition": [
		"40a6",
		9
	],
	"./api/works/WinningScientificCompetition.js": [
		"40a6",
		9
	],
	"./api/xlsx": [
		"3f0f",
		9
	],
	"./api/xlsx.js": [
		"3f0f",
		9
	],
	"./assets/fonts/Manrope-Bold.woff": [
		"54ed",
		7,
		"chunk-2d0c8874"
	],
	"./assets/fonts/Manrope-ExtraBold.woff": [
		"cbd7",
		7,
		"chunk-2d221de8"
	],
	"./assets/fonts/Manrope-Medium.woff": [
		"2c8e",
		7,
		"chunk-2d0bd654"
	],
	"./assets/fonts/Manrope-Regular.woff": [
		"5a30",
		7,
		"chunk-2d0d2b1f"
	],
	"./assets/fonts/Manrope-Semibold.woff": [
		"2700",
		7,
		"chunk-2d0b2ffb"
	],
	"./assets/logo.png": [
		"cf05",
		7
	],
	"./assets/styles/alternateCssStyles.css": [
		"1fc1",
		7,
		"chunk-7462d546"
	],
	"./assets/styles/font.css": [
		"712d",
		7,
		"chunk-749e98dd"
	],
	"./assets/styles/icons.css": [
		"01da",
		7,
		"chunk-bba68bf6",
		"chunk-2d0a3734"
	],
	"./assets/styles/index.css": [
		"c898",
		7,
		"chunk-bba68bf6",
		"chunk-e24533ec"
	],
	"./assets/styles/main.css": [
		"927c",
		7,
		"chunk-74bb4ee4"
	],
	"./assets/styles/shadow.css": [
		"31a3",
		7,
		"chunk-7466e559"
	],
	"./assets/styles/toast.css": [
		"22fb",
		7,
		"chunk-74595aad"
	],
	"./assets/styles/uiElements/alert.css": [
		"5dff",
		7,
		"chunk-749a5c3a"
	],
	"./assets/styles/uiElements/button.css": [
		"1ed3",
		7,
		"chunk-746264e6"
	],
	"./assets/styles/uiElements/card.css": [
		"4ce3",
		7,
		"chunk-748bc66c"
	],
	"./assets/styles/uiElements/filter.css": [
		"3f8c",
		7,
		"chunk-747e68eb"
	],
	"./assets/styles/uiElements/input.css": [
		"1b99",
		7,
		"chunk-74606718"
	],
	"./assets/styles/uiElements/links.css": [
		"add1",
		7,
		"chunk-77065879"
	],
	"./assets/styles/uiElements/list.css": [
		"52bb",
		7,
		"chunk-7483922c"
	],
	"./assets/styles/uiElements/tab.css": [
		"3d7b",
		7,
		"chunk-747d7c4d"
	],
	"./assets/styles/uiElements/table.css": [
		"ac59",
		7,
		"chunk-770534a3"
	],
	"./assets/styles/uiElements/text.css": [
		"fc59",
		7,
		"chunk-774baa28"
	],
	"./components/Auth/PasswordCreate": [
		"5114",
		9,
		"chunk-9f088146"
	],
	"./components/Auth/PasswordCreate.vue": [
		"5114",
		9,
		"chunk-9f088146"
	],
	"./components/Employee/EditorialBoardCard": [
		"ecde",
		9,
		"chunk-bd026660"
	],
	"./components/Employee/EditorialBoardCard.vue": [
		"ecde",
		9,
		"chunk-bd026660"
	],
	"./components/Employee/IndicatorsOfScientificActivity": [
		"15a5",
		9,
		"chunk-03991f08"
	],
	"./components/Employee/IndicatorsOfScientificActivity.vue": [
		"15a5",
		9,
		"chunk-03991f08"
	],
	"./components/Employee/PersonalDataCard": [
		"8542",
		9,
		"chunk-f71c4b28"
	],
	"./components/Employee/PersonalDataCard.vue": [
		"8542",
		9,
		"chunk-f71c4b28"
	],
	"./components/Employee/PositionsCard": [
		"7040",
		9,
		"chunk-429396c6"
	],
	"./components/Employee/PositionsCard.vue": [
		"7040",
		9,
		"chunk-429396c6"
	],
	"./components/JournalEditorialBoards/JournalsFilter": [
		"851d",
		9,
		"chunk-08e765bc"
	],
	"./components/JournalEditorialBoards/JournalsFilter.vue": [
		"851d",
		9,
		"chunk-08e765bc"
	],
	"./components/Publications/Opposition/dialogs/OppositionDialog": [
		"3663",
		9,
		"chunk-22bc336e"
	],
	"./components/Publications/Opposition/dialogs/OppositionDialog.vue": [
		"3663",
		9,
		"chunk-22bc336e"
	],
	"./components/Publications/Protected/ProtectedFilters": [
		"1e49",
		9,
		"chunk-d9129e68"
	],
	"./components/Publications/Protected/ProtectedFilters.vue": [
		"1e49",
		9,
		"chunk-d9129e68"
	],
	"./components/Publications/ThePublicationsTabs": [
		"f10f",
		9,
		"chunk-2d22bcf7"
	],
	"./components/Publications/ThePublicationsTabs.vue": [
		"f10f",
		9,
		"chunk-2d22bcf7"
	],
	"./components/Works/CommonWorkParent/CommonWorkFilters": [
		"daaf",
		9,
		"chunk-853fada2"
	],
	"./components/Works/CommonWorkParent/CommonWorkFilters.vue": [
		"daaf",
		9,
		"chunk-853fada2"
	],
	"./components/Works/Contest/ContestCard": [
		"24a2",
		9,
		"chunk-1c343d88",
		"chunk-36eaedd3"
	],
	"./components/Works/Contest/ContestCard.vue": [
		"24a2",
		9,
		"chunk-1c343d88",
		"chunk-36eaedd3"
	],
	"./components/Works/CooperationInformation/CooperationInformationCard": [
		"af60",
		9,
		"chunk-5bd68471"
	],
	"./components/Works/CooperationInformation/CooperationInformationCard.vue": [
		"af60",
		9,
		"chunk-5bd68471"
	],
	"./components/Works/Dissertation/DissertationCard": [
		"768c",
		9,
		"chunk-18ab5f7b"
	],
	"./components/Works/Dissertation/DissertationCard.vue": [
		"768c",
		9,
		"chunk-18ab5f7b"
	],
	"./components/Works/EducationalPublication/EducationalPublicationCard": [
		"be1f",
		9,
		"chunk-f332875a",
		"chunk-36eaedd3"
	],
	"./components/Works/EducationalPublication/EducationalPublicationCard.vue": [
		"be1f",
		9,
		"chunk-f332875a",
		"chunk-36eaedd3"
	],
	"./components/Works/ForeignCitation/ForeignCitationCard": [
		"5ac6",
		9,
		"chunk-4d9716d1"
	],
	"./components/Works/ForeignCitation/ForeignCitationCard.vue": [
		"5ac6",
		9,
		"chunk-4d9716d1"
	],
	"./components/Works/Grant/GrantCard": [
		"0f04",
		9,
		"chunk-3857daa2",
		"chunk-36eaedd3"
	],
	"./components/Works/Grant/GrantCard.vue": [
		"0f04",
		9,
		"chunk-3857daa2",
		"chunk-36eaedd3"
	],
	"./components/Works/Incalculation/IncalculationCard": [
		"6be2",
		9,
		"chunk-41f246d4",
		"chunk-36eaedd3"
	],
	"./components/Works/Incalculation/IncalculationCard.vue": [
		"6be2",
		9,
		"chunk-41f246d4",
		"chunk-36eaedd3"
	],
	"./components/Works/Monography/MonographyCard": [
		"c7f3",
		9,
		"chunk-1a13a297"
	],
	"./components/Works/Monography/MonographyCard.vue": [
		"c7f3",
		9,
		"chunk-1a13a297"
	],
	"./components/Works/Monography/PagesInTheEditionCard": [
		"61c2",
		9,
		"chunk-8708f3fc"
	],
	"./components/Works/Monography/PagesInTheEditionCard.vue": [
		"61c2",
		9,
		"chunk-8708f3fc"
	],
	"./components/Works/Monography/PublisherInformationCard": [
		"4f19",
		9,
		"chunk-0d1b3c20"
	],
	"./components/Works/Monography/PublisherInformationCard.vue": [
		"4f19",
		9,
		"chunk-0d1b3c20"
	],
	"./components/Works/NirAccomplishment/NirAccomplishmentCard": [
		"892f",
		9,
		"chunk-43419207"
	],
	"./components/Works/NirAccomplishment/NirAccomplishmentCard.vue": [
		"892f",
		9,
		"chunk-43419207"
	],
	"./components/Works/NirCompensationCard/NirCompensationAgreementCard": [
		"0f47",
		9,
		"chunk-2b6ca0b4"
	],
	"./components/Works/NirCompensationCard/NirCompensationAgreementCard.vue": [
		"0f47",
		9,
		"chunk-2b6ca0b4"
	],
	"./components/Works/OverseasEvent/OverseasEventCard": [
		"d0fa",
		9,
		"chunk-54180e44"
	],
	"./components/Works/OverseasEvent/OverseasEventCard.vue": [
		"d0fa",
		9,
		"chunk-54180e44"
	],
	"./components/Works/PeerReviewedPublication/PeerReviewedPublicationCard": [
		"6d6d",
		9,
		"chunk-49cde0b8"
	],
	"./components/Works/PeerReviewedPublication/PeerReviewedPublicationCard.vue": [
		"6d6d",
		9,
		"chunk-49cde0b8"
	],
	"./components/Works/Performance/PerformanceCard": [
		"cdc6",
		9,
		"chunk-68496962",
		"chunk-36eaedd3"
	],
	"./components/Works/Performance/PerformanceCard.vue": [
		"cdc6",
		9,
		"chunk-68496962",
		"chunk-36eaedd3"
	],
	"./components/Works/PrePrint/PrePrintCard": [
		"cbbd",
		9,
		"chunk-87f827cc",
		"chunk-43b59765"
	],
	"./components/Works/PrePrint/PrePrintCard.vue": [
		"cbbd",
		9,
		"chunk-87f827cc",
		"chunk-43b59765"
	],
	"./components/Works/PublicOrganizationParticipation/PublicOrganizationParticipationCard": [
		"0a4d",
		9,
		"chunk-26ee0d1a"
	],
	"./components/Works/PublicOrganizationParticipation/PublicOrganizationParticipationCard.vue": [
		"0a4d",
		9,
		"chunk-26ee0d1a"
	],
	"./components/Works/Publication/PublicationCard": [
		"055e",
		9,
		"chunk-2042e870"
	],
	"./components/Works/Publication/PublicationCard.vue": [
		"055e",
		9,
		"chunk-2042e870"
	],
	"./components/Works/Publication/PublicationPagesInTheEditionCard": [
		"0d45",
		9,
		"chunk-04e599ad"
	],
	"./components/Works/Publication/PublicationPagesInTheEditionCard.vue": [
		"0d45",
		9,
		"chunk-04e599ad"
	],
	"./components/Works/ScientificPracticalEvent/ScientificPracticalEventCard": [
		"0f4c",
		9,
		"chunk-271fda74"
	],
	"./components/Works/ScientificPracticalEvent/ScientificPracticalEventCard.vue": [
		"0f4c",
		9,
		"chunk-271fda74"
	],
	"./components/Works/StateAward/StateAwardCard": [
		"a496",
		9,
		"chunk-060a9661"
	],
	"./components/Works/StateAward/StateAwardCard.vue": [
		"a496",
		9,
		"chunk-060a9661"
	],
	"./components/Works/StudentGuide/StudentGuideCard": [
		"98d1",
		9,
		"chunk-4152ab2c",
		"chunk-5f095502"
	],
	"./components/Works/StudentGuide/StudentGuideCard.vue": [
		"98d1",
		9,
		"chunk-4152ab2c",
		"chunk-5f095502"
	],
	"./components/Works/WinningScientificCompetition/WinningScientificCompetitionCard": [
		"5c2a",
		9,
		"chunk-392d16b4"
	],
	"./components/Works/WinningScientificCompetition/WinningScientificCompetitionCard.vue": [
		"5c2a",
		9,
		"chunk-392d16b4"
	],
	"./components/Works/elements/AuthorsCard": [
		"530e",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24"
	],
	"./components/Works/elements/AuthorsCard.vue": [
		"530e",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24"
	],
	"./components/Works/elements/CommentCard": [
		"c2ac",
		9,
		"chunk-6f690be8"
	],
	"./components/Works/elements/CommentCard.vue": [
		"c2ac",
		9,
		"chunk-6f690be8"
	],
	"./components/Works/elements/CreatorCard": [
		"bcd5",
		9,
		"chunk-3ff89702"
	],
	"./components/Works/elements/CreatorCard.vue": [
		"bcd5",
		9,
		"chunk-3ff89702"
	],
	"./components/Works/elements/SpecialityCard": [
		"e6f5",
		9,
		"chunk-e81522dc"
	],
	"./components/Works/elements/SpecialityCard.vue": [
		"e6f5",
		9,
		"chunk-e81522dc"
	],
	"./components/Works/elements/TitleCard": [
		"05f2",
		9,
		"chunk-247f6f70"
	],
	"./components/Works/elements/TitleCard.vue": [
		"05f2",
		9,
		"chunk-247f6f70"
	],
	"./components/Works/elements/WorkTitleCard": [
		"9b2e",
		9,
		"chunk-2d0f0072"
	],
	"./components/Works/elements/WorkTitleCard.vue": [
		"9b2e",
		9,
		"chunk-2d0f0072"
	],
	"./components/commonWork/dialogs/CommonWorkCreation": [
		"6968",
		9,
		"chunk-1178e114"
	],
	"./components/commonWork/dialogs/CommonWorkCreation.vue": [
		"6968",
		9,
		"chunk-1178e114"
	],
	"./components/dialogs/Confirm": [
		"726d",
		9,
		"chunk-5ee4dbe9"
	],
	"./components/dialogs/Confirm.vue": [
		"726d",
		9,
		"chunk-5ee4dbe9"
	],
	"./components/directories/DirectoryTablePage": [
		"e07e",
		9,
		"chunk-a22ee204"
	],
	"./components/directories/DirectoryTablePage.vue": [
		"e07e",
		9,
		"chunk-a22ee204"
	],
	"./components/directories/councilMember/dialogs/CouncilMember": [
		"93ab",
		9,
		"chunk-484f85c7",
		"chunk-36bf810a"
	],
	"./components/directories/councilMember/dialogs/CouncilMember.vue": [
		"93ab",
		9,
		"chunk-484f85c7",
		"chunk-36bf810a"
	],
	"./components/directories/employee/EmployeeFilters": [
		"6fe9",
		9,
		"chunk-7bc43e52"
	],
	"./components/directories/employee/EmployeeFilters.vue": [
		"6fe9",
		9,
		"chunk-7bc43e52"
	],
	"./components/directories/employee/dialogs/Employee": [
		"600f",
		9,
		"chunk-7b21f1d3"
	],
	"./components/directories/employee/dialogs/Employee.vue": [
		"600f",
		9,
		"chunk-7b21f1d3"
	],
	"./components/directories/employee/dialogs/EmployeePosition": [
		"d551",
		9,
		"chunk-fea62a08"
	],
	"./components/directories/employee/dialogs/EmployeePosition.vue": [
		"d551",
		9,
		"chunk-fea62a08"
	],
	"./components/directories/employee/dialogs/EmployeePositionList": [
		"c6b7",
		9,
		"chunk-0c496159"
	],
	"./components/directories/employee/dialogs/EmployeePositionList.vue": [
		"c6b7",
		9,
		"chunk-0c496159"
	],
	"./components/directories/magazine/dialogs/MagazineDialog": [
		"4ba2",
		9,
		"chunk-9c6141fc"
	],
	"./components/directories/magazine/dialogs/MagazineDialog.vue": [
		"4ba2",
		9,
		"chunk-9c6141fc"
	],
	"./components/directories/period/dialogs/Period": [
		"e238",
		9,
		"chunk-25cbb143"
	],
	"./components/directories/period/dialogs/Period.vue": [
		"e238",
		9,
		"chunk-25cbb143"
	],
	"./components/directories/protectionPlace/dialogs/ProtectionPlace": [
		"ba39",
		9,
		"chunk-eac0b272"
	],
	"./components/directories/protectionPlace/dialogs/ProtectionPlace.vue": [
		"ba39",
		9,
		"chunk-eac0b272"
	],
	"./components/directories/publishingHouse/dialogs/PublishingHouse": [
		"f3de",
		9,
		"chunk-463c039e"
	],
	"./components/directories/publishingHouse/dialogs/PublishingHouse.vue": [
		"f3de",
		9,
		"chunk-463c039e"
	],
	"./components/directories/speciality/dialogs/Speciality": [
		"b645",
		9,
		"chunk-270fcb10"
	],
	"./components/directories/speciality/dialogs/Speciality.vue": [
		"b645",
		9,
		"chunk-270fcb10"
	],
	"./components/ui/BaseDialog": [
		"ae92",
		9
	],
	"./components/ui/BaseDialog.vue": [
		"ae92",
		9
	],
	"./components/ui/DialogCardActions": [
		"516f",
		9
	],
	"./components/ui/DialogCardActions.vue": [
		"516f",
		9
	],
	"./components/ui/DialogCardTitle": [
		"784d",
		9
	],
	"./components/ui/DialogCardTitle.vue": [
		"784d",
		9
	],
	"./components/ui/FilterChips": [
		"2591",
		9,
		"chunk-5e81b2ff"
	],
	"./components/ui/FilterChips.vue": [
		"2591",
		9,
		"chunk-5e81b2ff"
	],
	"./components/ui/LeftMenu": [
		"91e3",
		9
	],
	"./components/ui/LeftMenu.vue": [
		"91e3",
		9
	],
	"./components/ui/MenuLinks": [
		"9d24",
		9
	],
	"./components/ui/MenuLinks.vue": [
		"9d24",
		9
	],
	"./components/ui/Navbar": [
		"5418",
		9
	],
	"./components/ui/Navbar.vue": [
		"5418",
		9
	],
	"./components/ui/SearchElement": [
		"ec7b",
		9,
		"chunk-47a685e8"
	],
	"./components/ui/SearchElement.vue": [
		"ec7b",
		9,
		"chunk-47a685e8"
	],
	"./components/ui/SimpleTextRow": [
		"5d19",
		9,
		"chunk-f49d4278"
	],
	"./components/ui/SimpleTextRow.vue": [
		"5d19",
		9,
		"chunk-f49d4278"
	],
	"./components/ui/UIAlert": [
		"75e5",
		9,
		"chunk-2d0d74c4"
	],
	"./components/ui/UIAlert.vue": [
		"75e5",
		9,
		"chunk-2d0d74c4"
	],
	"./components/ui/UIAutocomplete": [
		"2153",
		9,
		"chunk-84b6be3c"
	],
	"./components/ui/UIAutocomplete.vue": [
		"2153",
		9,
		"chunk-84b6be3c"
	],
	"./components/ui/UIDatePickerMenu": [
		"c9da",
		9,
		"chunk-63411914"
	],
	"./components/ui/UIDatePickerMenu.vue": [
		"c9da",
		9,
		"chunk-63411914"
	],
	"./components/ui/UITabs": [
		"305b",
		9,
		"chunk-b16f1f26"
	],
	"./components/ui/UITabs.vue": [
		"305b",
		9,
		"chunk-b16f1f26"
	],
	"./components/ui/UITextArea": [
		"ba91",
		9,
		"chunk-5462583c"
	],
	"./components/ui/UITextArea.vue": [
		"ba91",
		9,
		"chunk-5462583c"
	],
	"./components/ui/UITextField": [
		"d4f7",
		9,
		"chunk-571e8975"
	],
	"./components/ui/UITextField.vue": [
		"d4f7",
		9,
		"chunk-571e8975"
	],
	"./components/ui/UIUploadFile": [
		"c8e9",
		9,
		"chunk-3a9f85df"
	],
	"./components/ui/UIUploadFile.vue": [
		"c8e9",
		9,
		"chunk-3a9f85df"
	],
	"./components/ui/row/CardAutocompleteRow": [
		"103b",
		9,
		"chunk-70711148"
	],
	"./components/ui/row/CardAutocompleteRow.vue": [
		"103b",
		9,
		"chunk-70711148"
	],
	"./components/ui/row/CardDateRow": [
		"1e7b",
		9,
		"chunk-dde9bfaa"
	],
	"./components/ui/row/CardDateRow.vue": [
		"1e7b",
		9,
		"chunk-dde9bfaa"
	],
	"./components/ui/row/CardFieldRow": [
		"1544",
		9,
		"chunk-07d85121"
	],
	"./components/ui/row/CardFieldRow.vue": [
		"1544",
		9,
		"chunk-07d85121"
	],
	"./components/ui/row/CardRadioRow": [
		"cb7a",
		9,
		"chunk-7bb00eee"
	],
	"./components/ui/row/CardRadioRow.vue": [
		"cb7a",
		9,
		"chunk-7bb00eee"
	],
	"./components/ui/row/CardRow": [
		"c4f8",
		9,
		"chunk-6d341144"
	],
	"./components/ui/row/CardRow.vue": [
		"c4f8",
		9,
		"chunk-6d341144"
	],
	"./components/ui/row/CardTextAreaRow": [
		"c001",
		9,
		"chunk-42f382e4"
	],
	"./components/ui/row/CardTextAreaRow.vue": [
		"c001",
		9,
		"chunk-42f382e4"
	],
	"./main": [
		"56d7",
		9
	],
	"./main.js": [
		"56d7",
		9
	],
	"./mixins/createWorkDisabled": [
		"d9f1",
		9,
		"chunk-2d21f896"
	],
	"./mixins/createWorkDisabled.js": [
		"d9f1",
		9,
		"chunk-2d21f896"
	],
	"./mixins/filesForWork": [
		"29da",
		9,
		"chunk-2d0b3dfa"
	],
	"./mixins/filesForWork.js": [
		"29da",
		9,
		"chunk-2d0b3dfa"
	],
	"./mixins/isEffContract": [
		"b589",
		9,
		"chunk-2d20fb4a"
	],
	"./mixins/isEffContract.js": [
		"b589",
		9,
		"chunk-2d20fb4a"
	],
	"./mixins/isVerticalScrollInTable": [
		"ad31",
		9,
		"chunk-52cd450e"
	],
	"./mixins/isVerticalScrollInTable.js": [
		"ad31",
		9,
		"chunk-52cd450e"
	],
	"./mixins/setExcludeType": [
		"8971",
		9,
		"chunk-2d0df291"
	],
	"./mixins/setExcludeType.js": [
		"8971",
		9,
		"chunk-2d0df291"
	],
	"./mixins/shadowForLastColumn": [
		"d9ec",
		9,
		"chunk-6c923f72"
	],
	"./mixins/shadowForLastColumn.js": [
		"d9ec",
		9,
		"chunk-6c923f72"
	],
	"./mixins/tableHeight": [
		"5a14",
		9,
		"chunk-1537108b"
	],
	"./mixins/tableHeight.js": [
		"5a14",
		9,
		"chunk-1537108b"
	],
	"./mixins/workListHeight": [
		"8897",
		9,
		"chunk-1395be08"
	],
	"./mixins/workListHeight.js": [
		"8897",
		9,
		"chunk-1395be08"
	],
	"./models": [
		"3a34",
		9
	],
	"./models/": [
		"3a34",
		9
	],
	"./models/AuthorWork": [
		"6486",
		9
	],
	"./models/AuthorWork.js": [
		"6486",
		9
	],
	"./models/BibliographyWork": [
		"77b5",
		9
	],
	"./models/BibliographyWork.js": [
		"77b5",
		9
	],
	"./models/CommonWork": [
		"9fcf",
		9
	],
	"./models/CommonWork.js": [
		"9fcf",
		9
	],
	"./models/CouncilMember": [
		"aeba",
		9
	],
	"./models/CouncilMember.js": [
		"aeba",
		9
	],
	"./models/EfficiencyMetric": [
		"cf6b",
		9
	],
	"./models/EfficiencyMetric.js": [
		"cf6b",
		9
	],
	"./models/EmployeeFilters": [
		"39b8",
		9
	],
	"./models/EmployeeFilters.js": [
		"39b8",
		9
	],
	"./models/EmployeePosition": [
		"511e",
		9
	],
	"./models/EmployeePosition.js": [
		"511e",
		9
	],
	"./models/File": [
		"93f3",
		9,
		"chunk-2d0e561d"
	],
	"./models/File.js": [
		"93f3",
		9,
		"chunk-2d0e561d"
	],
	"./models/Filters": [
		"327c",
		9
	],
	"./models/Filters.js": [
		"327c",
		9
	],
	"./models/JournalEditorialBoards": [
		"6e8d",
		9,
		"chunk-2d0daf51"
	],
	"./models/JournalEditorialBoards.js": [
		"6e8d",
		9,
		"chunk-2d0daf51"
	],
	"./models/List": [
		"ef9b",
		9
	],
	"./models/List.js": [
		"ef9b",
		9
	],
	"./models/Opposition": [
		"e729",
		9
	],
	"./models/Opposition.js": [
		"e729",
		9
	],
	"./models/Report": [
		"3f37",
		9
	],
	"./models/Report.js": [
		"3f37",
		9
	],
	"./models/Role": [
		"0006",
		9
	],
	"./models/Role.js": [
		"0006",
		9
	],
	"./models/Speciality": [
		"aee5",
		9
	],
	"./models/Speciality.js": [
		"aee5",
		9
	],
	"./models/auth": [
		"757e",
		9
	],
	"./models/auth.js": [
		"757e",
		9
	],
	"./models/directories/Bibliography": [
		"bbcb",
		9
	],
	"./models/directories/Bibliography.js": [
		"bbcb",
		9
	],
	"./models/directories/CouncilName": [
		"971f",
		9
	],
	"./models/directories/CouncilName.js": [
		"971f",
		9
	],
	"./models/directories/Employee": [
		"8fee",
		9
	],
	"./models/directories/Employee.js": [
		"8fee",
		9
	],
	"./models/directories/Magazine": [
		"0e33",
		9
	],
	"./models/directories/Magazine.js": [
		"0e33",
		9
	],
	"./models/directories/Period": [
		"afc9",
		9,
		"chunk-23c3affb"
	],
	"./models/directories/Period.js": [
		"afc9",
		9,
		"chunk-23c3affb"
	],
	"./models/directories/ProtectionPlace": [
		"c0f9",
		9
	],
	"./models/directories/ProtectionPlace.js": [
		"c0f9",
		9
	],
	"./models/directories/PublishingHouse": [
		"600d",
		9
	],
	"./models/directories/PublishingHouse.js": [
		"600d",
		9
	],
	"./models/directories/Speciality": [
		"5245",
		9
	],
	"./models/directories/Speciality.js": [
		"5245",
		9
	],
	"./models/index": [
		"3a34",
		9
	],
	"./models/index.js": [
		"3a34",
		9
	],
	"./models/works/Contest": [
		"32d3",
		9
	],
	"./models/works/Contest.js": [
		"32d3",
		9
	],
	"./models/works/ContestBody": [
		"f139",
		9
	],
	"./models/works/ContestBody.js": [
		"f139",
		9
	],
	"./models/works/CooperationInformation": [
		"4322",
		9
	],
	"./models/works/CooperationInformation.js": [
		"4322",
		9
	],
	"./models/works/Dissertation": [
		"9728",
		9
	],
	"./models/works/Dissertation.js": [
		"9728",
		9
	],
	"./models/works/EducationalPublication": [
		"0525",
		9
	],
	"./models/works/EducationalPublication.js": [
		"0525",
		9
	],
	"./models/works/ForeignCitation": [
		"b0a2",
		9
	],
	"./models/works/ForeignCitation.js": [
		"b0a2",
		9
	],
	"./models/works/Grant": [
		"584f",
		9
	],
	"./models/works/Grant.js": [
		"584f",
		9
	],
	"./models/works/Incalculation": [
		"0489",
		9
	],
	"./models/works/Incalculation.js": [
		"0489",
		9
	],
	"./models/works/Monography": [
		"d794",
		9
	],
	"./models/works/Monography.js": [
		"d794",
		9
	],
	"./models/works/NirAccomplishment": [
		"3009",
		9
	],
	"./models/works/NirAccomplishment.js": [
		"3009",
		9
	],
	"./models/works/NirCompensationAgreement": [
		"1f6f",
		9,
		"chunk-2d0b6cfb"
	],
	"./models/works/NirCompensationAgreement.js": [
		"1f6f",
		9,
		"chunk-2d0b6cfb"
	],
	"./models/works/OverseasEvent": [
		"79b2",
		9
	],
	"./models/works/OverseasEvent.js": [
		"79b2",
		9
	],
	"./models/works/PeerReviewedPublication": [
		"5c72",
		9
	],
	"./models/works/PeerReviewedPublication.js": [
		"5c72",
		9
	],
	"./models/works/Performance": [
		"efb6",
		9
	],
	"./models/works/Performance.js": [
		"efb6",
		9
	],
	"./models/works/PrePrint": [
		"36b9",
		9
	],
	"./models/works/PrePrint.js": [
		"36b9",
		9
	],
	"./models/works/PublicOrganizationParticipation": [
		"f75a",
		9
	],
	"./models/works/PublicOrganizationParticipation.js": [
		"f75a",
		9
	],
	"./models/works/Publication": [
		"a94a",
		9
	],
	"./models/works/Publication.js": [
		"a94a",
		9
	],
	"./models/works/ScientificPracticalEvent": [
		"22c6",
		9,
		"chunk-2d0b2369"
	],
	"./models/works/ScientificPracticalEvent.js": [
		"22c6",
		9,
		"chunk-2d0b2369"
	],
	"./models/works/StateAward": [
		"9160",
		9
	],
	"./models/works/StateAward.js": [
		"9160",
		9
	],
	"./models/works/StudentGuide": [
		"77cf",
		9
	],
	"./models/works/StudentGuide.js": [
		"77cf",
		9
	],
	"./models/works/WinningScientificCompetition": [
		"1601",
		9,
		"chunk-2d0ab7dc"
	],
	"./models/works/WinningScientificCompetition.js": [
		"1601",
		9,
		"chunk-2d0ab7dc"
	],
	"./pages/Auth/ForgetPassword": [
		"a1aa",
		9,
		"chunk-38f29e3e"
	],
	"./pages/Auth/ForgetPassword.vue": [
		"a1aa",
		9,
		"chunk-38f29e3e"
	],
	"./pages/Auth/Login": [
		"80ab",
		9,
		"chunk-68ce2472"
	],
	"./pages/Auth/Login.vue": [
		"80ab",
		9,
		"chunk-68ce2472"
	],
	"./pages/Auth/Registration": [
		"9a16",
		9,
		"chunk-35e7dec4"
	],
	"./pages/Auth/Registration.vue": [
		"9a16",
		9,
		"chunk-35e7dec4"
	],
	"./pages/Efficiency": [
		"f7b4",
		9,
		"chunk-853fada2",
		"chunk-4a8bd026"
	],
	"./pages/Efficiency.vue": [
		"f7b4",
		9,
		"chunk-853fada2",
		"chunk-4a8bd026"
	],
	"./pages/Employee": [
		"26f8",
		9,
		"chunk-4f7ff66e"
	],
	"./pages/Employee.vue": [
		"26f8",
		9,
		"chunk-4f7ff66e"
	],
	"./pages/JournalEditorialBoards/Index": [
		"615d",
		9,
		"chunk-2d0cebc0"
	],
	"./pages/JournalEditorialBoards/Index.vue": [
		"615d",
		9,
		"chunk-2d0cebc0"
	],
	"./pages/JournalEditorialBoards/JournalPage": [
		"b799",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-07f044ba"
	],
	"./pages/JournalEditorialBoards/JournalPage.vue": [
		"b799",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-07f044ba"
	],
	"./pages/JournalEditorialBoards/Journals": [
		"5cc4",
		9,
		"chunk-08e765bc",
		"chunk-7b832db1"
	],
	"./pages/JournalEditorialBoards/Journals.vue": [
		"5cc4",
		9,
		"chunk-08e765bc",
		"chunk-7b832db1"
	],
	"./pages/JournalEditorialBoards/elements/EmployeeCard": [
		"e771",
		9,
		"chunk-e3761a5c"
	],
	"./pages/JournalEditorialBoards/elements/EmployeeCard.vue": [
		"e771",
		9,
		"chunk-e3761a5c"
	],
	"./pages/JournalEditorialBoards/elements/MainInformationCard": [
		"5ada",
		9,
		"chunk-446c44f2"
	],
	"./pages/JournalEditorialBoards/elements/MainInformationCard.vue": [
		"5ada",
		9,
		"chunk-446c44f2"
	],
	"./pages/NotFound": [
		"aa4b",
		9,
		"chunk-2d212bc4"
	],
	"./pages/NotFound.vue": [
		"aa4b",
		9,
		"chunk-2d212bc4"
	],
	"./pages/Publications": [
		"c9f8",
		9,
		"chunk-2d21843e"
	],
	"./pages/Publications/": [
		"c9f8",
		9,
		"chunk-2d21843e"
	],
	"./pages/Publications/Opposition": [
		"ffcf",
		9,
		"chunk-853fada2",
		"chunk-e9a46560"
	],
	"./pages/Publications/Opposition.vue": [
		"ffcf",
		9,
		"chunk-853fada2",
		"chunk-e9a46560"
	],
	"./pages/Publications/Points": [
		"401e",
		9,
		"chunk-358a1cf9"
	],
	"./pages/Publications/Points.vue": [
		"401e",
		9,
		"chunk-358a1cf9"
	],
	"./pages/Publications/Protected": [
		"75c6",
		9,
		"chunk-aee0633c"
	],
	"./pages/Publications/Protected.vue": [
		"75c6",
		9,
		"chunk-aee0633c"
	],
	"./pages/Publications/PublicationsParent": [
		"762d",
		9,
		"chunk-853fada2",
		"chunk-1bb5f551"
	],
	"./pages/Publications/PublicationsParent.vue": [
		"762d",
		9,
		"chunk-853fada2",
		"chunk-1bb5f551"
	],
	"./pages/Publications/index": [
		"c9f8",
		9,
		"chunk-2d21843e"
	],
	"./pages/Publications/index.vue": [
		"c9f8",
		9,
		"chunk-2d21843e"
	],
	"./pages/Works": [
		"34f5",
		9,
		"chunk-2d0b9fa6"
	],
	"./pages/Works/": [
		"34f5",
		9,
		"chunk-2d0b9fa6"
	],
	"./pages/Works/CommonWork": [
		"ebdd",
		9,
		"chunk-853fada2",
		"chunk-a2cee3ce"
	],
	"./pages/Works/CommonWork/": [
		"ebdd",
		9,
		"chunk-853fada2",
		"chunk-a2cee3ce"
	],
	"./pages/Works/CommonWork/AllWorks": [
		"ac64",
		9,
		"chunk-1b611c30"
	],
	"./pages/Works/CommonWork/AllWorks.vue": [
		"ac64",
		9,
		"chunk-1b611c30"
	],
	"./pages/Works/CommonWork/Decline": [
		"fb47",
		9,
		"chunk-2786df2f"
	],
	"./pages/Works/CommonWork/Decline.vue": [
		"fb47",
		9,
		"chunk-2786df2f"
	],
	"./pages/Works/CommonWork/Review": [
		"3bf5",
		9,
		"chunk-611cd0e4"
	],
	"./pages/Works/CommonWork/Review.vue": [
		"3bf5",
		9,
		"chunk-611cd0e4"
	],
	"./pages/Works/CommonWork/index": [
		"ebdd",
		9,
		"chunk-853fada2",
		"chunk-a2cee3ce"
	],
	"./pages/Works/CommonWork/index.vue": [
		"ebdd",
		9,
		"chunk-853fada2",
		"chunk-a2cee3ce"
	],
	"./pages/Works/ContestPage": [
		"7b37",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-1c343d88",
		"chunk-61fa68d6"
	],
	"./pages/Works/ContestPage.vue": [
		"7b37",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-1c343d88",
		"chunk-61fa68d6"
	],
	"./pages/Works/CooperationInformationPage": [
		"2d23",
		9,
		"chunk-5bd68471",
		"chunk-5ee229a4"
	],
	"./pages/Works/CooperationInformationPage.vue": [
		"2d23",
		9,
		"chunk-5bd68471",
		"chunk-5ee229a4"
	],
	"./pages/Works/DissertationPage": [
		"cbe8",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-81156414"
	],
	"./pages/Works/DissertationPage.vue": [
		"cbe8",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-81156414"
	],
	"./pages/Works/EducationalPublicationPage": [
		"4d1f",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-f332875a",
		"chunk-051bbf1d"
	],
	"./pages/Works/EducationalPublicationPage.vue": [
		"4d1f",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-f332875a",
		"chunk-051bbf1d"
	],
	"./pages/Works/ForeignCitationPage": [
		"5f99",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-8afa7bec"
	],
	"./pages/Works/ForeignCitationPage.vue": [
		"5f99",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-8afa7bec"
	],
	"./pages/Works/GrantPage": [
		"b30a",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-3857daa2",
		"chunk-b39ea300"
	],
	"./pages/Works/GrantPage.vue": [
		"b30a",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-3857daa2",
		"chunk-b39ea300"
	],
	"./pages/Works/IncalculationPage": [
		"e395",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-41f246d4",
		"chunk-41f4e110"
	],
	"./pages/Works/IncalculationPage.vue": [
		"e395",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-41f246d4",
		"chunk-41f4e110"
	],
	"./pages/Works/MonographyPage": [
		"51f3",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-22bbb8d2"
	],
	"./pages/Works/MonographyPage.vue": [
		"51f3",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-22bbb8d2"
	],
	"./pages/Works/NirAccomplishmentPage": [
		"fbd2",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-e888cb9a"
	],
	"./pages/Works/NirAccomplishmentPage.vue": [
		"fbd2",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-e888cb9a"
	],
	"./pages/Works/NirCompensationAgreementsPage": [
		"8de3",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-4225923e"
	],
	"./pages/Works/NirCompensationAgreementsPage.vue": [
		"8de3",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-4225923e"
	],
	"./pages/Works/OverseasEventPage": [
		"f635",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-195196d4"
	],
	"./pages/Works/OverseasEventPage.vue": [
		"f635",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-195196d4"
	],
	"./pages/Works/PeerReviewedPublicationPage": [
		"f138",
		9,
		"chunk-2e04eb8a"
	],
	"./pages/Works/PeerReviewedPublicationPage.vue": [
		"f138",
		9,
		"chunk-2e04eb8a"
	],
	"./pages/Works/PerformancePage": [
		"265f",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-68496962",
		"chunk-3313f20d"
	],
	"./pages/Works/PerformancePage.vue": [
		"265f",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-68496962",
		"chunk-3313f20d"
	],
	"./pages/Works/PrePrintPage": [
		"ff02",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-87f827cc",
		"chunk-49797d06"
	],
	"./pages/Works/PrePrintPage.vue": [
		"ff02",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-87f827cc",
		"chunk-49797d06"
	],
	"./pages/Works/PublicOrganizationParticipationPage": [
		"97a3",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-3db8984e"
	],
	"./pages/Works/PublicOrganizationParticipationPage.vue": [
		"97a3",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-3db8984e"
	],
	"./pages/Works/PublicationPage": [
		"cebf",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-43b862c2"
	],
	"./pages/Works/PublicationPage.vue": [
		"cebf",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-43b862c2"
	],
	"./pages/Works/ScientificPracticalEvent": [
		"1242",
		9,
		"chunk-271fda74",
		"chunk-16525410"
	],
	"./pages/Works/ScientificPracticalEvent.vue": [
		"1242",
		9,
		"chunk-271fda74",
		"chunk-16525410"
	],
	"./pages/Works/StateAwardPage": [
		"6daa",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-61c90cee"
	],
	"./pages/Works/StateAwardPage.vue": [
		"6daa",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-61c90cee"
	],
	"./pages/Works/StudentGuidePage": [
		"5756",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-4152ab2c",
		"chunk-c4c60710"
	],
	"./pages/Works/StudentGuidePage.vue": [
		"5756",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-4152ab2c",
		"chunk-c4c60710"
	],
	"./pages/Works/WinningScientificCompetition": [
		"5cfe",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-964edc4a"
	],
	"./pages/Works/WinningScientificCompetition.vue": [
		"5cfe",
		9,
		"chunk-484f85c7",
		"chunk-25f75b24",
		"chunk-964edc4a"
	],
	"./pages/Works/index": [
		"34f5",
		9,
		"chunk-2d0b9fa6"
	],
	"./pages/Works/index.vue": [
		"34f5",
		9,
		"chunk-2d0b9fa6"
	],
	"./pages/directories": [
		"91e4",
		9,
		"chunk-57a3dff2"
	],
	"./pages/directories/": [
		"91e4",
		9,
		"chunk-57a3dff2"
	],
	"./pages/directories/CouncilMemberParent": [
		"eed6",
		9,
		"chunk-484f85c7",
		"chunk-7711461e"
	],
	"./pages/directories/CouncilMemberParent.vue": [
		"eed6",
		9,
		"chunk-484f85c7",
		"chunk-7711461e"
	],
	"./pages/directories/EmployeeParent": [
		"22ea",
		9,
		"chunk-7bc43e52",
		"chunk-0586ca61"
	],
	"./pages/directories/EmployeeParent.vue": [
		"22ea",
		9,
		"chunk-7bc43e52",
		"chunk-0586ca61"
	],
	"./pages/directories/MagazineParent": [
		"24a7",
		9,
		"chunk-65468ee2"
	],
	"./pages/directories/MagazineParent.vue": [
		"24a7",
		9,
		"chunk-65468ee2"
	],
	"./pages/directories/PeriodParent": [
		"f503",
		9,
		"chunk-e2d58834"
	],
	"./pages/directories/PeriodParent.vue": [
		"f503",
		9,
		"chunk-e2d58834"
	],
	"./pages/directories/ProtectionPlaceParent": [
		"3c0d",
		9,
		"chunk-484f85c7",
		"chunk-7e69c37b"
	],
	"./pages/directories/ProtectionPlaceParent.vue": [
		"3c0d",
		9,
		"chunk-484f85c7",
		"chunk-7e69c37b"
	],
	"./pages/directories/PublishingHouseParent": [
		"9246",
		9,
		"chunk-484f85c7",
		"chunk-69b4d6e8"
	],
	"./pages/directories/PublishingHouseParent.vue": [
		"9246",
		9,
		"chunk-484f85c7",
		"chunk-69b4d6e8"
	],
	"./pages/directories/SpecialityParent": [
		"7d7c",
		9,
		"chunk-484f85c7",
		"chunk-24f67671"
	],
	"./pages/directories/SpecialityParent.vue": [
		"7d7c",
		9,
		"chunk-484f85c7",
		"chunk-24f67671"
	],
	"./pages/directories/index": [
		"91e4",
		9,
		"chunk-57a3dff2"
	],
	"./pages/directories/index.vue": [
		"91e4",
		9,
		"chunk-57a3dff2"
	],
	"./plugins/download": [
		"d0f3",
		9
	],
	"./plugins/download.js": [
		"d0f3",
		9
	],
	"./plugins/vuetify": [
		"402c",
		9
	],
	"./plugins/vuetify.js": [
		"402c",
		9
	],
	"./router": [
		"a18c",
		9
	],
	"./router/": [
		"a18c",
		9
	],
	"./router/index": [
		"a18c",
		9
	],
	"./router/index.js": [
		"a18c",
		9
	],
	"./router/links": [
		"3cdc",
		9
	],
	"./router/links.js": [
		"3cdc",
		9
	],
	"./router/pageAccesses": [
		"15a8",
		9
	],
	"./router/pageAccesses.js": [
		"15a8",
		9
	],
	"./scripts": [
		"1590",
		9,
		"chunk-260d884f"
	],
	"./scripts/": [
		"1590",
		9,
		"chunk-260d884f"
	],
	"./scripts/consts": [
		"761f",
		9
	],
	"./scripts/consts.js": [
		"761f",
		9
	],
	"./scripts/formatDate": [
		"2124",
		9
	],
	"./scripts/formatDate.js": [
		"2124",
		9
	],
	"./scripts/formatLogin": [
		"023d",
		9,
		"chunk-2d0a3509"
	],
	"./scripts/formatLogin.js": [
		"023d",
		9,
		"chunk-2d0a3509"
	],
	"./scripts/formatString": [
		"2df5",
		9,
		"chunk-2d0bdf77"
	],
	"./scripts/formatString.js": [
		"2df5",
		9,
		"chunk-2d0bdf77"
	],
	"./scripts/index": [
		"1590",
		9,
		"chunk-260d884f"
	],
	"./scripts/index.js": [
		"1590",
		9,
		"chunk-260d884f"
	],
	"./scripts/publicationFullBibliographicDescription": [
		"e40e",
		9
	],
	"./scripts/publicationFullBibliographicDescription.js": [
		"e40e",
		9
	],
	"./scripts/report": [
		"b7d4",
		9
	],
	"./scripts/report.js": [
		"b7d4",
		9
	],
	"./scripts/sort": [
		"adb8",
		9
	],
	"./scripts/sort.js": [
		"adb8",
		9
	],
	"./scripts/validation": [
		"16dc",
		9
	],
	"./scripts/validation.js": [
		"16dc",
		9
	],
	"./store": [
		"4360",
		9
	],
	"./store/": [
		"4360",
		9
	],
	"./store/index": [
		"4360",
		9
	],
	"./store/index.js": [
		"4360",
		9
	],
	"./store/pages/dictionaries": [
		"e594",
		9
	],
	"./store/pages/dictionaries.js": [
		"e594",
		9
	],
	"./store/pages/directoryPage": [
		"efef",
		9
	],
	"./store/pages/directoryPage.js": [
		"efef",
		9
	],
	"./store/pages/filters": [
		"814e",
		9
	],
	"./store/pages/filters.js": [
		"814e",
		9
	],
	"./store/pages/workTypes": [
		"7577",
		9
	],
	"./store/pages/workTypes.js": [
		"7577",
		9
	],
	"./store/user": [
		"2147",
		9
	],
	"./store/user.js": [
		"2147",
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8673";
module.exports = webpackAsyncContext;